import { Model } from '../Model.js';
import { DropOffOpeningTime, WeekDay } from './DropOffOpeningTime.js';

var _dec, _class;

/**
 * Plain object DropOff representation.
 */

/**
 * Serialized object DropOff representation.
 */

/**
 * Plain object Packlink's API response representation.
 */

let DropOff = (_dec = Model(), _dec(_class = class DropOff {
  /**
   * Takes a IDropOffApiResponse from Packlink's API and returns a DropOff.
   *
   * @param response  IDropOffApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    const openingTimesApi = response.opening_times.opening_times;
    const openingTimes = Object.keys(openingTimesApi).map(day => DropOffOpeningTime.createFromResponse({
      [day]: openingTimesApi[day]
    }));
    return new DropOff(response.address, response.commerce_name, response.city, response.id, response.lat, response.long, response.zip, openingTimes);
  }

  /**
   * Takes a serialized DropOff and returns a DropOff.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized DropOff.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedDropOff.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of DropOff.
   *
   */

  /**
   * Takes a serialized DropOff and returns a DropOff.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized DropOff.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedDropOff.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of DropOff.
   *
   */

  /**
   * Takes a serialized DropOff and returns a DropOff.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized DropOff.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedDropOff.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of DropOff.
   *
   */

  /**
   * Takes a serialized DropOff and returns a DropOff.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized DropOff.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedDropOff.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of DropOff.
   *
   */
  static deserialize(data) {
    var _data$openingTimes;
    if (!data) {
      return;
    }
    return new DropOff(data.address, data.businessName, data.city, data.id, data.lat, data.lng, data.zipCode, (_data$openingTimes = data.openingTimes) === null || _data$openingTimes === void 0 ? void 0 : _data$openingTimes.map(dropOffOpeningTime => DropOffOpeningTime.deserialize(dropOffOpeningTime)));
  }

  /**
   * Returns a new DropOff. Typings of the properties depend on the class type param T
   *
   */
  constructor(address, businessName, city, id, lat, lng, zipCode, openingTimes) {
    this.address = address;
    this.businessName = businessName;
    this.city = city;
    this.id = id;
    this.lat = lat;
    this.lng = lng;
    this.zipCode = zipCode;
    this.openingTimes = openingTimes;
  }

  /**
   * Returns a JSON serialized version of the DropOff.
   *
   */
  toJSON() {
    var _this$openingTimes;
    return {
      address: this.address,
      businessName: this.businessName,
      city: this.city,
      id: this.id,
      lat: this.lat,
      lng: this.lng,
      openingTimes: (_this$openingTimes = this.openingTimes) === null || _this$openingTimes === void 0 ? void 0 : _this$openingTimes.map(openingTime => openingTime.toJSON()),
      zipCode: this.zipCode
    };
  }

  /**
   * Returns a clone of the DropOff.
   *
   */
  clone() {
    var _this$openingTimes2;
    return new DropOff(this.address, this.businessName, this.city, this.id, this.lat, this.lng, this.zipCode, (_this$openingTimes2 = this.openingTimes) === null || _this$openingTimes2 === void 0 ? void 0 : _this$openingTimes2.map(openingTime => openingTime.clone()));
  }

  /**
   * Returns whether the two DropOff are equal.
   *
   */
  equals(dropOff) {
    var _this$openingTimes3;
    if (!dropOff) {
      return false;
    }
    return this.address === dropOff.address && this.businessName === dropOff.businessName && this.city === dropOff.city && this.id === dropOff.id && this.lat === dropOff.lat && this.lng === dropOff.lng && !!((_this$openingTimes3 = this.openingTimes) !== null && _this$openingTimes3 !== void 0 && _this$openingTimes3.reduce((areEqual, element, index) => areEqual && dropOff.openingTimes && element.equals(dropOff.openingTimes[index]), true)) && this.zipCode === dropOff.zipCode;
  }
  sortOpeningTimes() {
    var _this$openingTimes4;
    const weekDayKeys = Object.keys(WeekDay);
    (_this$openingTimes4 = this.openingTimes) === null || _this$openingTimes4 === void 0 ? void 0 : _this$openingTimes4.sort((a, b) => {
      if (a.day && b.day) {
        return weekDayKeys.indexOf(a.day.toUpperCase()) < weekDayKeys.indexOf(b.day.toUpperCase()) ? -1 : 1;
      }
      return 0;
    });
  }
}) || _class);

export { DropOff };
//# sourceMappingURL=DropOff.js.map
